$(document).ready(function() {

    if ($(".ttgQuickNaviWeather, .ttgQuickNaviIconStaticWeather").length) {

        var actLang = $(".ttgDataWrapperOnlyNeededForJS").attr("data-actLanguage");
        var sysLang = $(".ttgDataWrapperOnlyNeededForJS").attr("data-actLanguageSysUid");
        var weatherURL = $(".ttgQuickNaviWeather").attr("data-weatherURL");
        var weatherURLTarget = $(".ttgQuickNaviWeather").attr("data-weatherURLTarget");
        var websiteConfigPid = $(".ttgQuickNaviWeather").attr("data-ajaxWebsiteConfigPid");

        $.ajax({
            type: "POST",
            url: "/wetter-ajax.html",
            data: "ajax=1&no_cache=1&language=" + actLang + "&syslang=" + sysLang + "&weatherURL=" + weatherURL + "&weatherURLTarget=" + weatherURLTarget + "&websiteConfigPid=" + websiteConfigPid,
            beforeSend: function(e) {},
            success: function(e) {
                $(".dynamicWeather").html(e); // #ttgQuickNaviWeather (gibts 2x wegen mobiler Positionierung)
            },
            // complete: function(e) {
            //     $.each($('#ttgQuickNaviWeather img[src$=".svg"], .ttgQuickNaviIconStaticWeather img[src$=".svg"]'), function(k, v) {
            //         var $img = $(this);
            //         var imgID = $img.attr('id');
            //         var imgClass = $img.attr('class');
            //         var imgURL = $img.attr('src').replace('//cdn.ttg.at', '');
            //         $.post(imgURL, function(data) {
            //             var $svg = $(data).find('svg');
            //             if (typeof imgID !== 'undefined') {
            //                 $svg = $svg.attr('id', imgID);
            //             }
            //             if (typeof imgClass !== 'undefined') {
            //                 $svg = $svg.attr('class', imgClass + ' replaced-svg');
            //             }
            //             $svg = $svg.removeAttr('xmlns:a');
            //             $img.replaceWith($svg);
            //         }, 'xml');
            //     });
            // },
            error: function(e) {}
        });
    }

    /************* ORTSWETTER AJAX AUF TOUR-DETAILSEITE *******************/
    if ($(".ttgMowisDetailseitenWetterContainer").attr("data-wetterkey")) {
        $(".ttgMowisDetailseitenWetterContainer").each(function() {
            var actLang = $(".ttgDataWrapperOnlyNeededForJS").attr("data-actlanguage");
            $.ajax({
                type: "POST",
                url: "/wetter-ajax.html",
                data: "ajax=1&wetterkey=" + $(this).attr("data-wetterkey") + "&no_cache=1&language=" + actLang,
                beforeSend: function(e) {},
                success: function(e) {
                    $(".ttgMowisDetailseitenWetterContainerInner").html(e);
                },
                error: function(e) {}
            });
        });
    }
});